// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"request-voice-modal_wrapper__Mm1Kh","container":"request-voice-modal_container__MfBQE","text":"request-voice-modal_text__qQ5LK"};